import controller from './vd-avatar-multi.controller'
import template from './vd-avatar-multi.html'

/**
 * VdAvatarMulti Component
 */
export default {
  bindings: {
    entities: '<',
  },
  controller,
  template,
}
